import React from 'react';
import * as Icons from '@material-ui/icons';

const DynamicMaterialIcon = ({ name, ...props }) => {
  const Icon = Icons[name];
  return <Icon {...props} />;
};

export default DynamicMaterialIcon;
